export default "__VITE_ASSET__c17535dd__"